import React, { useState, useEffect, useCallback } from "react";
import { fetchHorarios } from "../../utils/fetchHorarios";
import "./styles.css";
import { formatHorario } from "../../utils/timeUtils";

const CardHorarios = ({ roomId, roomName, selectedDate, onClickSchedule }) => {
  const [schedules, setSchedules] = useState([]);

  const updateSchedules = useCallback(() => {
    if (roomId && selectedDate) {
      fetchHorarios(roomId, selectedDate, setSchedules);
    }
  }, [roomId, selectedDate]);

  useEffect(() => {
    updateSchedules();
  }, [updateSchedules]);

  const handleScheduleClick = (schedule) => {
    onClickSchedule(roomName, { ...schedule, roomId });
    updateSchedules();
  };

  return (
    <div className="schedules">
      {schedules.map((schedule) => (
        <button
          key={schedule._id}
          className={`schedule-button ${schedule.status}`}
          disabled={schedule.status !== "livre"}
          onClick={() => handleScheduleClick(schedule)}
        >
          <span className="schedule-time">{formatHorario(schedule.horario, roomName)}</span>
          {schedule.status !== "livre" && (
            <span className="status">{schedule.status.toUpperCase()}</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default CardHorarios;